import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { StyledPriceWrapper, StyledSalePrice, StyledSalePriceRange, StyledPriceCrossedOut } from './CollectionCardPriceStyles';

import { getSelectedVariantPrices, getCurrency } from '../../Utils/PriceUtils';

var CollectionCardPrice = function CollectionCardPrice(props) {
  var variantPrices = getSelectedVariantPrices(props.selectedVariant);

  var minVariantPrice = props.showPriceRange && getCurrency(props.priceRange.minVariantPrice.currencyCode, props.priceRange.minVariantPrice.amount);
  var maxVariantPrice = props.showPriceRange && getCurrency(props.priceRange.maxVariantPrice.currencyCode, props.priceRange.maxVariantPrice.amount);

  var minVariantPriceOriginal = minVariantPrice && props.variants.edges[0].node && props.variants.edges.find(function (variant) {
    return getSelectedVariantPrices(variant.node).price === minVariantPrice;
  }) && props.variants.edges.find(function (variant) {
    return getSelectedVariantPrices(variant.node).price === minVariantPrice;
  }).node.compareAtPriceV2 && props.variants.edges.find(function (variant) {
    return getSelectedVariantPrices(variant.node).price === minVariantPrice;
  }).node.compareAtPriceV2.amount;

  var maxVariantPriceOriginal = maxVariantPrice && props.variants.edges.find(function (variant) {
    return getSelectedVariantPrices(variant.node).price === maxVariantPrice;
  }) && props.variants.edges.find(function (variant) {
    return getSelectedVariantPrices(variant.node).price === maxVariantPrice;
  }).node.compareAtPriceV2 && props.variants.edges.find(function (variant) {
    return getSelectedVariantPrices(variant.node).price === maxVariantPrice;
  }).node.compareAtPriceV2.amount;

  var showDiscountedPriceRange = minVariantPriceOriginal || maxVariantPriceOriginal;
  return React.createElement(
    StyledPriceWrapper,
    null,
    props.showPriceRange ? React.createElement(
      Fragment,
      null,
      React.createElement(
        StyledSalePriceRange,
        { sale: showDiscountedPriceRange },
        'From ',
        minVariantPrice.replace('.00', ''),
        ' -',
        ' ',
        maxVariantPrice.replace('.00', '')
      ),
      showDiscountedPriceRange && React.createElement(
        StyledPriceCrossedOut,
        null,
        'From $',
        minVariantPriceOriginal ? minVariantPriceOriginal.replace('.0', '') : minVariantPrice.replace('.00', ''),
        ' ',
        '- $',
        maxVariantPriceOriginal ? maxVariantPriceOriginal.replace('.0', '') : maxVariantPrice.replace('.00', '')
      )
    ) : React.createElement(
      Fragment,
      null,
      React.createElement(
        StyledSalePrice,
        { sale: variantPrices.compareAtPrice },
        variantPrices.price.replace('.00', '')
      ),
      variantPrices.compareAtPrice && React.createElement(
        StyledPriceCrossedOut,
        null,
        variantPrices.compareAtPrice.replace('.00', '')
      )
    )
  );
};

CollectionCardPrice.propTypes = {
  selectedVariant: PropTypes.object,
  showPriceRange: PropTypes.bool,
  priceRange: PropTypes.object,
  variants: PropTypes.object
};

export default CollectionCardPrice;